import type { AccessibilityFocusRef, UniversalFocusOptions } from './types';

export type { UniversalFocusOptions } from './types';

function hasFocusMethod(value: unknown): value is { focus: () => void } {
    return value != null && typeof value === 'object' && 'focus' in value && typeof value.focus === 'function';
}

/**
 * Sets focus on the referenced element using the DOM focus() API.
 *
 * @returns `true` if the focus request was dispatched, `false` if the ref was empty.
 */
export function setAccessibilityFocus(ref: AccessibilityFocusRef): boolean {
    const element: unknown = ref.current;
    if (hasFocusMethod(element)) {
        element.focus();
        return true;
    }
    return false;
}

/**
 * Sets focus on the referenced element using the DOM focus() API.
 * The `keyboardFocus` option is a no-op on web since DOM focus already
 * covers both screen-reader and keyboard focus.
 *
 * @returns `true` if the focus request was dispatched, `false` if the ref was empty.
 */
export function setUniversalFocus(
    ref: AccessibilityFocusRef,
    _options: UniversalFocusOptions = {},
): boolean {
    return setAccessibilityFocus(ref);
}
